// src/utils/clientId.js

import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'playmoment_client_id';

export function getClientId() {
  let id = localStorage.getItem(STORAGE_KEY);
  if (!id) {
    id = uuidv4();
    localStorage.setItem(STORAGE_KEY, id);
  }
  return id;
}
